import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';

export const VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST = 'VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST';
export const VOLCANO_LOCATION_SEARCH_COUNTRY_SUCCESS = 'VOLCANO_LOCATION_SEARCH_COUNTRY_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_COUNTRY_FAILURE = 'VOLCANO_LOCATION_SEARCH_COUNTRY_FAILURE';

export const CLEAR_VOLCANO_LOCATIONS = 'CLEAR_VOLCANO_LOCATIONS';
export const CLEAR_VOLCANO_LOCATION_REDIRECT = 'CLEAR_VOLCANO_LOCATION_REDIRECT';

export const GET_VOLCANO_LOCATIONS_REQUEST = 'GET_VOLCANO_LOCATIONS_REQUEST';
export const GET_VOLCANO_LOCATIONS_SUCCESS = 'GET_VOLCANO_LOCATIONS_SUCCESS';
export const GET_VOLCANO_LOCATIONS_FAILURE = 'GET_VOLCANO_LOCATIONS_FAILURE';

export const VOLCANO_LOCATION_SEARCH_REGION_REQUEST = 'VOLCANO_LOCATION_SEARCH_REGION_REQUEST';
export const VOLCANO_LOCATION_SEARCH_REGION_SUCCESS = 'VOLCANO_LOCATION_SEARCH_REGION_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_REGION_FAILURE = 'VOLCANO_LOCATION_SEARCH_REGION_FAILURE';

export const VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST = 'VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST';
export const VOLCANO_LOCATION_SEARCH_MORPHOLOGY_SUCCESS = 'VOLCANO_LOCATION_SEARCH_MORPHOLOGY_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_MORPHOLOGY_FAILURE = 'VOLCANO_LOCATION_SEARCH_MORPHOLOGY_FAILURE';

export const VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_REQUEST = 'VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_REQUEST';
export const VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_SUCCESS = 'VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_FAILURE = 'VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_FAILURE';

export const VOLCANO_LOCATION_SEARCH_STATUS_REQUEST = 'VOLCANO_LOCATION_SEARCH_STATUS_REQUEST';
export const VOLCANO_LOCATION_SEARCH_STATUS_SUCCESS = 'VOLCANO_LOCATION_SEARCH_STATUS_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_STATUS_FAILURE = 'VOLCANO_LOCATION_SEARCH_STATUS_FAILURE';

export const VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST = 'VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST';
export const VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_SUCCESS = 'VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_SUCCESS';
export const VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_FAILURE = 'VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_FAILURE';


export const VOLCANO_LOCATION_DATA_SORT = 'VOLCANO_LOCATION_DATA_SORT';

const initialState = fromJS({
  searching: false,
  fetched: false,
  volcanoes: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedMorphologies: false,
  morphologies: [],
  fetchedVolcanoNames: false,
  volcanoNames: [],
  fetchedStatuses: false,
  statuses: [],
  fetchedEruptionTimes: false,
  eruptionTimes: [],

  sort: [{ id: 'location', asc: true }, { id: 'country', asc: true }, { id: 'name', asc: true }],
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoLocationSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VOLCANO_LOCATION_REDIRECT:
      return state.set('searchRedirect', false);
    case CLEAR_VOLCANO_LOCATIONS:
      return initialState.set('sort', state.get('sort'));

    case VOLCANO_LOCATION_DATA_SORT:
      return state.merge(fromJS({
        volcanoes: basicSort(action.sort, state.get('volcanoes')),
        sort: action.sort,
      }));

    case GET_VOLCANO_LOCATIONS_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case GET_VOLCANO_LOCATIONS_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        volcanoes: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_VOLCANO_LOCATIONS_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case VOLCANO_LOCATION_SEARCH_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case VOLCANO_LOCATION_SEARCH_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case VOLCANO_LOCATION_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST:
      return state.merge(fromJS({
        fetchedMorphologies: false,
      }));
    case VOLCANO_LOCATION_SEARCH_MORPHOLOGY_SUCCESS:
      return state.merge(fromJS({
        fetchedMorphologies: true,
        morphologies: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_MORPHOLOGY_FAILURE:
      return state.merge(fromJS({
        fetchedMorphologies: true,
      }));

    case VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_REQUEST:
      return state.merge(fromJS({
        fetchedVolcanoNames: false,
      }));
    case VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcanoNames: true,
        volcanoNames: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_FAILURE:
      return state.merge(fromJS({
        fetchedVolcanoNames: true,
      }));

    case VOLCANO_LOCATION_SEARCH_STATUS_REQUEST:
      return state.merge(fromJS({
        fetchedStatuses: false,
      }));
    case VOLCANO_LOCATION_SEARCH_STATUS_SUCCESS:
      return state.merge(fromJS({
        fetchedStatuses: true,
        statuses: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_STATUS_FAILURE:
      return state.merge(fromJS({
        fetchedStatuses: true,
      }));

    case VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST:
      return state.merge(fromJS({
        fetchedEruptionTimes: false,
      }));
    case VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_SUCCESS:
      return state.merge(fromJS({
        fetchedEruptionTimes: true,
        eruptionTimes: action.response.items,
      }));
    case VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_FAILURE:
      return state.merge(fromJS({
        fetchedEruptionTimes: true,
      }));

    default:
      return state;
  }
};
